export const urlRegex = /https?:\/\/[a-z0-9/:%_+.,#?!@&=-]+/
